import React, {Component} from "react";
import "./Awards.css";

import awards from "awards";

export default class Awards extends Component
{
	render()
	{
		const awardDisplay = awards.map((data, i) =>
		{
			return (
				<div key={i} className="item">
					<div className="image-container">
						<img src={data.image} alt={data.name + ", " + data.date} className={"image " + data.className} />
					</div>

					<div className="text">
						<div className="event">
							{data.event}
						</div>

						<div className="name">
							{data.name}
						</div>

						{/*<div className="date">
							{data.date}
						</div>*/}
					</div>
				</div>
			);
		});

		return (
			<div className="awards">
				{awardDisplay}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/Awards/Awards.js